export default __webpack_public_path__ + "CFs_email.html";